/* Cart reward bar, one-time flow (OCT-6-Cart 1, made permanent 15 Oct 2026). Source: output/2026-10-06-cart-reward-bar/.
   A cart with a single one-time Mushroom Gummies line gets a one-goal bar instead of the free-shipping bar:
   1 pack -> "Add 1 more to get 15% off + FREE SHIPPING"; 2+ packs -> "Unlocked: 15% off + FREE SHIPPING".
   The Buy-2 pill and Upgrade to Subscription button are hidden for that cart. Any other cart is left as the theme draws it.
   Re-applies after every drawer re-render. Namespaced awo-* / __awoCart so the Cart 2 Intelligems code (aw-* / __awCart) is unaffected. */
(function () {
  if (window.__awoCart) return;
  window.__awoCart = true;
  var MG = 49693443326241;
  var TRUCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v10h-11zM13.5 9.5h4l3 3v4h-7z"/><circle cx="6.5" cy="17.5" r="1.8" fill="#fff"/><circle cx="17" cy="17.5" r="1.8" fill="#fff"/></svg>';

  function lines(drawer) {
    var out = [];
    drawer.querySelectorAll('tr.cart-item').forEach(function (tr) {
      var inp = tr.querySelector('.quantity__input');
      if (!inp) return;
      out.push({ vid: +inp.getAttribute('data-quantity-variant-id'), qty: +inp.value, otp: !!tr.querySelector('.cart-item__subscription-btn') });
    });
    return out;
  }

  function apply() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var pb = drawer.querySelector('.cart-drawer__progress-bar');
    var ls = lines(drawer), l = ls[0];
    if (!pb || ls.length !== 1 || l.vid !== MG || !l.otp) { drawer.classList.remove('awo-on'); return; }
    var done = l.qty > 1, key = done ? '2' : '1';
    drawer.classList.add('awo-on');
    if (pb.getAttribute('data-awo') === key) return;
    pb.setAttribute('data-awo', key);
    pb.innerHTML = '<div class="awo-tier"><div class="awo-seg"><i style="width:' + (done ? 100 : 50) + '%"></i></div>' +
      '<span class="awo-m ' + (done ? 'awo-done' : 'awo-next') + '">' + TRUCK + '<em>15% off + free shipping</em></span></div>' +
      (done ? '<p class="awo-msg">Unlocked: <b>15% off</b> + <b>FREE SHIPPING</b></p>'
            : '<p class="awo-msg">Add 1 more to get <b>15% off</b> + <b>FREE SHIPPING</b></p>');
  }

  function boot() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(apply).observe(drawer, { childList: true, subtree: true });
    apply();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
